import { createSlice } from '@reduxjs/toolkit';

const previousDataSlice = createSlice({
  name: "previousData",
  initialState: { pdfPages: [], selectedDocument: null },
  reducers: {
    pdfPreviousDetails(state, action) {
      const { payload } = action;
      return { ...state, pdfPages: payload };
    },
    currPreviousDocument(state, action) {
      const { payload } = action;
      return { ...state, selectedDocument: payload };
    },
    updatePreviousSelectedDocument(state, action) {
      const { payload } = action;
      return { ...state, selectedDocument: {...state.selectedDocument, document_template:payload} };
    },
  },
});

export const { pdfPreviousDetails, currPreviousDocument, updatePreviousSelectedDocument } =
previousDataSlice.actions;
export default previousDataSlice.reducer;
